import React from 'react';
import { renderChildBloks, loadComponents } from '@/utils/story-composer';
import PageMetadata from './page-metadata';

loadComponents(require.context('@/components', true, /\.js$/));

function Layout({
	children,
	layout,
	location,
	metadata,
	localizations,
	isLibrary = false,
	disableHeader = false,
	disableFooter = false,
}) {
	let header = 'Header not found. Did you publish the layout?';
	let footer = 'Footer not found. Did you publish the layout?';

	if (layout) {
		const renderedLayout = renderChildBloks(['header', 'footer'], layout.content, {
			localizations,
			location,
			isLibrary,
		});

		header = renderedLayout.header;
		footer = renderedLayout.footer;
	}

	return (
		<div className="flex flex-col min-h-screen">
			<PageMetadata metadata={metadata} />
			{disableHeader !== true && <div className="h-20">{header}</div>}
			{children}
			{disableFooter !== true && <div className="flex-grow justify-end flex w-full flex-col">{footer}</div>}
		</div>
	);
}

export default Layout;
